import React, { useState, useEffect } from 'react';
import { logInteraction, pickVisibleFields, pickCommerceFields } from '../utils/utils';

// "Pagar anual" is seasonal: set to true to show the button again
const SHOW_PAGO_ANUAL = false;

/* SidePanel: Responsive panel (Right on desktop, Bottom on mobile) */
function SidePanel({ open, parcelPages, activeParcelIndex, setActiveParcelIndex, commerceDataList, preferredTab, onClose, onZoom, onConsultarLito, onNotify }) {
    const [showPayOptions, setShowPayOptions] = useState(false);
    const [activeTab, setActiveTab] = useState('inmueble'); // 'inmueble' | 'comercio'
    const [activeCommerceIndex, setActiveCommerceIndex] = useState(0);

    // Reset payment view when switching pages or closing
    useEffect(() => {
        setShowPayOptions(false);
    }, [activeParcelIndex, activeTab, open]);

    // Reset commerce index when list changes
    useEffect(() => {
        setActiveCommerceIndex(0);
    }, [commerceDataList]);

    // Logic to switch tab default
    useEffect(() => {
        if (open) {
            // Use preferredTab if provided
            if (preferredTab) {
                setActiveTab(preferredTab);
            } else if (!parcelPages || parcelPages.length === 0) {
                if (commerceDataList && commerceDataList.length > 0) setActiveTab('comercio');
            } else {
                setActiveTab('inmueble');
            }
        }
    }, [open, parcelPages, commerceDataList, preferredTab]);



    if (!open) return null;

    const renderInmueble = () => {
        const page = parcelPages[activeParcelIndex];
        if (!page) return <div>Sin datos de inmueble</div>;
        const main = pickVisibleFields(page.properties || {});

        // ... logic for Pay, WhatsApp ...
        const onWhatsApp = () => {
            onConsultarLito(`IM${main.id_contribuyente || ''}`);
        };

        const handlePayOption = (type) => {
            const id = main.id_contribuyente;
            if (!id) { onNotify('No hay ID de contribuyente disponible.'); return; }

            let baseUrl = `https://www.municipioonline.com.ar/newsite/Views/resumenDeudaGet.php?m=rawson&tipoCo=IM&idCo=${id}`;

            if (type === 'deuda') {
                // Base URL is fine
            } else if (type === 'semestre') {
                baseUrl += '&tipoboleta=2';
            } else if (type === 'anual') {
                baseUrl += '&tipoboleta=a';
            } else {
                onNotify('Opción no implementada: ' + type);
                return;
            }
            logInteraction(id, type, baseUrl);
            window.open(baseUrl, '_blank', 'noopener,noreferrer');
        };

        return (
            <>
                <div style={{ background: '#fafafa', padding: 10, borderRadius: 6, marginBottom: 12 }}>
                    <div className="info-row">
                        <span className="info-label">Nomenclatura</span>
                        <span className="info-value">{main.Nomenclatura}</span>
                    </div>
                    <div className="info-row">
                        <span className="info-label">Responsable</span>
                        <span className="info-value">{main.Nombre}</span>
                    </div>
                    <div className="info-row">
                        <span className="info-label">Domicilio</span>
                        <span className="info-value">{main.domicilio}</span>
                    </div>
                    {main.id_contribuyente && (
                        <div className="info-row">
                            <span className="info-label">ID Contribuyente</span>
                            <span className="info-value">{main.id_contribuyente}</span>
                        </div>
                    )}
                </div>

                <div className="action-buttons">
                    {!showPayOptions ? (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', width: '100%' }}>
                            <div style={{ display: 'flex', gap: '10px', width: '100%' }}>
                                <button onClick={() => setShowPayOptions(true)} className="btn btn-primary">Pagar Ahora</button>
                                <button onClick={onWhatsApp} className="btn btn-success" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                        <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" />
                                    </svg>
                                    Consultar a Lito
                                </button>
                            </div>
                            <div style={{ fontSize: '11px', color: '#666', textAlign: 'center', lineHeight: '1.4' }}>
                                Para pedir que te enviemos tus boletas, planes de pago, libre deuda, cambiar el responsable de pago y otros trámites tocá "Consultar a Lito"
                            </div>
                        </div>
                    ) : (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%' }}>
                            <button onClick={() => handlePayOption('deuda')} className="btn btn-primary">Ponerse al día</button>
                            <button onClick={() => handlePayOption('semestre')} className="btn btn-primary">Pagar semestre</button>
                            {SHOW_PAGO_ANUAL && <button onClick={() => handlePayOption('anual')} className="btn btn-primary">Pagar anual</button>}
                            <button onClick={() => setShowPayOptions(false)} className="btn btn-secondary">Volver</button>
                        </div>
                    )}
                </div>

                {parcelPages.length > 1 && (
                    <div className="nav-buttons">
                        <button onClick={() => setActiveParcelIndex(i => Math.max(0, i - 1))} disabled={activeParcelIndex === 0} className={`btn ${activeParcelIndex === 0 ? 'btn-secondary' : 'btn-primary'}`}>◀ Anterior</button>
                        <span style={{ fontSize: 13, color: '#666' }}>{activeParcelIndex + 1} / {parcelPages.length}</span>
                        <button onClick={() => setActiveParcelIndex(i => Math.min(parcelPages.length - 1, i + 1))} disabled={activeParcelIndex === parcelPages.length - 1} className={`btn ${activeParcelIndex === parcelPages.length - 1 ? 'btn-secondary' : 'btn-primary'}`}>Siguiente ▶</button>
                    </div>
                )}
            </>
        );
    };

    const renderComercio = () => {
        if (!commerceDataList || commerceDataList.length === 0) return <div>No se detectó comercio en esta ubicación.</div>;

        const currentCom = commerceDataList[activeCommerceIndex];
        if (!currentCom) return null; // Safety check if index is stale

        const info = pickCommerceFields(currentCom.properties || {});

        const onWhatsApp = () => {
            onConsultarLito(`CO${info.id_contribuyente || ''}`);
        };

        const handlePayOption = (type) => {
            const id = info.id_contribuyente;
            if (!id || id === '-') { onNotify('No hay ID de comercio disponible.'); return; }

            let baseUrl = `https://www.municipioonline.com.ar/newsite/Views/resumenDeudaGet.php?m=rawson&tipoCo=CO&idCo=${id}`;

            if (type === 'deuda') {
                // Base URL
            } else if (type === 'semestre') {
                baseUrl += '&tipoboleta=2';
            } else if (type === 'anual') {
                baseUrl += '&tipoboleta=a';
            } else {
                onNotify('Opción no implementada: ' + type);
                return;
            }
            logInteraction(id, type, baseUrl);
            window.open(baseUrl, '_blank', 'noopener,noreferrer');
        };

        return (
            <div key={activeCommerceIndex} style={{ background: '#fefefe', padding: 10, borderRadius: 6 }}>
                <div style={{ marginBottom: 12, paddingBottom: 8, borderBottom: '1px solid #eee', fontWeight: 'bold', color: '#007bff', display: 'flex', justifyContent: 'space-between' }}>
                    <span>Información Comercial</span>
                    {commerceDataList.length > 1 && (
                        <span style={{ fontSize: 12, color: '#666' }}>{activeCommerceIndex + 1} de {commerceDataList.length}</span>
                    )}
                </div>
                <div className="info-row">
                    <span className="info-label">ID Comercio</span>
                    <span className="info-value">{info.id_contribuyente}</span>
                </div>
                <div className="info-row">
                    <span className="info-label">Razón Social</span>
                    <span className="info-value text-right" style={{ maxWidth: '60%' }}>{info.razon_social}</span>
                </div>
                <div className="info-row">
                    <span className="info-label">Rubro</span>
                    <span className="info-value">{info.rubro}</span>
                </div>
                <div className="info-row">
                    <span className="info-label">Domicilio</span>
                    <span className="info-value">{info.domicilio}</span>
                </div>

                <div className="action-buttons" style={{ marginTop: 12 }}>
                    {!showPayOptions ? (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', width: '100%' }}>
                            <div style={{ display: 'flex', gap: '10px', width: '100%' }}>
                                <button onClick={() => setShowPayOptions(true)} className="btn btn-primary">Pagar Ahora</button>
                                <button onClick={onWhatsApp} className="btn btn-success" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                        <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" />
                                    </svg>
                                    Consultar a Lito
                                </button>
                            </div>
                            <div style={{ fontSize: '11px', color: '#666', textAlign: 'center', lineHeight: '1.4' }}>
                                Para pedir que te enviemos tus boletas, planes de pago, libre deuda, cambiar el responsable de pago y otros trámites tocá "Consultar a Lito"
                            </div>
                        </div>
                    ) : (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%' }}>
                            <button onClick={() => handlePayOption('deuda')} className="btn btn-primary">Ponerse al día</button>
                            <button onClick={() => handlePayOption('semestre')} className="btn btn-primary">Pagar semestre</button>
                            {SHOW_PAGO_ANUAL && <button onClick={() => handlePayOption('anual')} className="btn btn-primary">Pagar anual</button>}
                            <button onClick={() => setShowPayOptions(false)} className="btn btn-secondary">Volver</button>
                        </div>
                    )}
                </div>

                {commerceDataList.length > 1 && (
                    <div className="nav-buttons" style={{ marginTop: 12 }}>
                        <button onClick={() => setActiveCommerceIndex(i => Math.max(0, i - 1))} disabled={activeCommerceIndex === 0} className={`btn ${activeCommerceIndex === 0 ? 'btn-secondary' : 'btn-primary'}`}>◀ Anterior</button>
                        <button onClick={() => setActiveCommerceIndex(i => Math.min(commerceDataList.length - 1, i + 1))} disabled={activeCommerceIndex === commerceDataList.length - 1} className={`btn ${activeCommerceIndex === commerceDataList.length - 1 ? 'btn-secondary' : 'btn-primary'}`}>Siguiente ▶</button>
                    </div>
                )}
            </div>
        );
    };

    const commerceCount = commerceDataList ? commerceDataList.length : 0;
    const commerceLabel = commerceCount > 1 ? `Comercios (${commerceCount})` : 'Comercio';

    return (
        <div className="side-panel">
            <div className="side-panel-card">
                <div className="side-panel-header">
                    <div style={{ display: 'flex', gap: 10 }}>
                        <button
                            onClick={() => setActiveTab('inmueble')}
                            className={`btn ${activeTab === 'inmueble' ? 'btn-primary' : 'btn-secondary'}`}
                            style={{ padding: '6px 12px', fontSize: 13, display: 'flex', alignItems: 'center', gap: '6px' }}
                        >
                            Inmueble
                            {activeTab === 'inmueble' && parcelPages[activeParcelIndex] && (
                                <span onClick={(e) => { e.stopPropagation(); onZoom(parcelPages[activeParcelIndex]); }} title="Acercar al mapa" style={{ cursor: 'pointer', fontSize: '14px' }}>🔍</span>
                            )}
                        </button>
                        {commerceCount > 0 && (
                            <button
                                onClick={() => setActiveTab('comercio')}
                                className={`btn ${activeTab === 'comercio' ? 'btn-primary' : 'btn-secondary'}`}
                                style={{ padding: '6px 12px', fontSize: 13, display: 'flex', alignItems: 'center', gap: '6px' }}
                            >
                                {commerceLabel}
                                {activeTab === 'comercio' && commerceDataList[activeCommerceIndex] && (
                                    <span onClick={(e) => { e.stopPropagation(); onZoom(commerceDataList[activeCommerceIndex]); }} title="Acercar al mapa" style={{ cursor: 'pointer', fontSize: '14px' }}>🔍</span>
                                )}
                            </button>
                        )}
                    </div>
                    <button onClick={onClose} className="btn btn-secondary" style={{ padding: '4px 8px', fontSize: '12px', marginLeft: 10 }}>X</button>
                </div>

                <div className="side-panel-content">
                    {activeTab === 'inmueble' && renderInmueble()}
                    {activeTab === 'comercio' && renderComercio()}
                </div>
            </div>
        </div>
    );
}

export default SidePanel;
